export const HISTORY_MENU_SERVICES_BATCH_SIZE = 5;
